import React from "react";
import { Link } from "react-router-dom";
import line from "../assets/line.png";

const SolutionSection = () => {
  const offerings = [
    { title: "HIS", desc: "Comprehensive hospital management for streamlined operations.", link: "/his" },
    { title: "EHR", desc: "Electronic health records for better patient data management.", link: "/ehr" },
    { title: "RCM", desc: "Revenue cycle management for optimized healthcare finances.", link: "/rcm" },
    { title: "LIMS", desc: "Laboratory information management for faster results.", link: "/lims" },
  ];

  return (
    <div className="mt-10 px-4 sm:px-6 md:px-10">
      {/* Heading */}
      <div className="mb-6 text-left">
        <div className="relative inline-block pb-2 ml-1 sm:ml-6">
          <span className="relative z-10 text-xl sm:text-2xl md:text-3xl font-bold">
            <span className="text-[#00CFFF]">WISE</span> Product Offerings
          </span>
          <img
            src={line}
            alt="underline"
            className="absolute left-0 bottom-0 h-[6px] w-full object-contain"
          />
        </div>
      </div>

      {/* Grid EXACTLY like first component */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 md:gap-10 lg:gap-12 max-w-6xl mx-auto">

        {offerings.map((item, i) =>
          item.title === "LIMS" ? null : (
            <div
              key={i}
              className="flex flex-col items-center text-center p-6 rounded-lg shadow hover:shadow-lg transition-all duration-300 bg-white"
            >
              {/* Title */}
              <h3 className="font-bold text-base sm:text-lg md:text-xl text-black mb-2">
                WISE - <span className="text-[#0077cc]">{item.title}</span>
              </h3>

              {/* Description */}
              <p className="text-xs sm:text-sm md:text-base text-gray-600 mb-4 leading-relaxed">
                {item.desc}
              </p>

              {/* Know More Button */}
             <Link
  to={item.link}
  className="
    inline-block px-6 py-3 
    border-2 border-purple-400 
    text-purple-600 
    bg-white 
    rounded-md
    font-semibold text-base md:text-lg
    hover:bg-[#4B0082] hover:text-white hover:border-[#4B0082]
    transition-all duration-200
  "
  style={{ fontFamily: 'Calibri, sans-serif' }}
>
  Know More
</Link>

            </div>
          )
        )}
      </div>
    </div>
  );
};

export default SolutionSection;